import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Plus, Minus } from "lucide-react";
import { COMPANY } from "@/lib/constants";

const faqs = [
  {
    q: "¿Hacen transporte Roll Off en Buenos Aires?",
    a: `Sí. Royal Eco realiza transporte Roll Off en Buenos Aires, tanto en CABA como en toda la Provincia de Buenos Aires. Proveemos, colocamos y retiramos contenedores roll off (volquetes) de gran capacidad para residuos industriales, escombros y descartes, con retiro programado y trazabilidad documentada. Pedí tu cotización por WhatsApp al ${COMPANY.whatsappDisplay}.`,
  },
  {
    q: "¿Qué es el transporte Roll Off?",
    a: "El transporte Roll Off es un servicio de logística que utiliza contenedores roll off (volquetes) de gran capacidad para el acopio, traslado y disposición de grandes volúmenes de residuos industriales, escombros y descartes. Royal Eco provee, coloca y retira los contenedores en obra, planta o depósito en la Provincia de Buenos Aires y CABA.",
  },
  {
    q: "¿Qué son los servicios atmosféricos?",
    a: "Los servicios atmosféricos se realizan con camiones atmosféricos que succionan, transportan y disponen líquidos, barros y efluentes. Incluyen la limpieza de pozos, cámaras sépticas y plantas de tratamiento, con disposición final en plantas habilitadas.",
  },
  {
    q: "¿Qué son los residuos especiales?",
    a: "Los residuos especiales son aquellos que, por su naturaleza peligrosa, química, electrónica o patogénica, requieren una gestión diferenciada para evitar daños al ambiente y a la salud. No pueden disponerse junto a los residuos comunes: exigen transporte, tratamiento y disposición final habilitados, con documentación de respaldo (manifiestos y certificado de disposición final). En la Provincia de Buenos Aires se rigen por la Ley N° 11.720 y el Ministerio de Ambiente (ex-OPDS).",
  },
  {
    q: "¿Qué residuos se consideran especiales?",
    a: "Se consideran residuos especiales los residuos peligrosos industriales, aceites usados, derivados de hidrocarburos, solventes, barros de procesos, residuos químicos, electrónicos y patogénicos, entre otros. Cada corriente debe clasificarse correctamente; Royal Eco te asesora en la clasificación y en el circuito de gestión habilitado en Buenos Aires.",
  },
  {
    q: "¿Qué dice la Ley 11.720 de residuos especiales?",
    a: "La Ley N° 11.720 de la Provincia de Buenos Aires regula la generación, manipulación, transporte, tratamiento y disposición final de los residuos especiales. Obliga a los generadores a inscribirse y a gestionar sus residuos mediante transportistas y operadores habilitados, con trazabilidad por manifiestos. Royal Eco opera bajo estos estándares del Ministerio de Ambiente PBA (ex-OPDS).",
  },
  {
    q: "¿Cómo es el tratamiento de residuos especiales y peligrosos?",
    a: "Royal Eco realiza la recolección, transporte y tratamiento de residuos especiales y peligrosos mediante inertización, tratamiento físico-químico y rellenos de seguridad. Cada operación cuenta con manifiestos electrónicos y certificado de disposición final, bajo habilitación del Ministerio de Ambiente de la Provincia de Buenos Aires (ex-OPDS).",
  },
  {
    q: "¿En qué zona presta servicios Royal Eco?",
    a: `Royal Eco opera en la Provincia de Buenos Aires y CABA. Podés solicitar una cotización por WhatsApp al ${COMPANY.whatsappDisplay} o por teléfono de oficina al ${COMPANY.officeDisplay}.`,
  },
];

export default function FAQ() {
  const [open, setOpen] = useState(0);

  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="bg-bone relative border-t-2 border-asphalt py-20 md:py-28"
    >
      <div className="max-w-[1500px] mx-auto px-5 md:px-8">
        <div className="grid lg:grid-cols-12 gap-10 items-end mb-12">
          <div className="lg:col-span-7">
            <div className="tag text-forest-600 mb-5 lime-rule">
              Preguntas frecuentes
            </div>
            <h2 className="font-display text-5xl sm:text-6xl md:text-7xl text-asphalt leading-[0.92]">
              Transporte Roll Off
              <br />
              <span className="text-forest-700">y residuos en Buenos Aires.</span>
            </h2>
          </div>
          <p className="lg:col-span-5 text-forest-600 leading-relaxed text-lg max-w-md">
            Resolvemos las dudas más frecuentes sobre transporte Roll Off,
            servicios atmosféricos y tratamiento de residuos especiales en CABA y
            la Provincia de Buenos Aires.
          </p>
        </div>

        <div className="border-t-2 border-asphalt">
          {faqs.map((item, i) => {
            const isOpen = open === i;
            return (
              <div key={i} className="border-b-2 border-asphalt">
                <h3>
                  <button
                    onClick={() => setOpen(isOpen ? -1 : i)}
                    data-testid={`faq-toggle-${i}`}
                    aria-expanded={isOpen}
                    className="w-full text-left py-7 flex items-center justify-between gap-6 group"
                  >
                    <span className="font-display text-2xl md:text-3xl text-asphalt group-hover:text-lime-600 transition-colors">
                      {item.q}
                    </span>
                    <span className="shrink-0 w-9 h-9 inline-flex items-center justify-center border-2 border-asphalt text-asphalt group-hover:bg-lime-400 group-hover:border-lime-400 transition-colors">
                      {isOpen ? (
                        <Minus className="w-4 h-4" />
                      ) : (
                        <Plus className="w-4 h-4" />
                      )}
                    </span>
                  </button>
                </h3>
                <AnimatePresence initial={false}>
                  {isOpen && (
                    <motion.div
                      initial={{ height: 0, opacity: 0 }}
                      animate={{ height: "auto", opacity: 1 }}
                      exit={{ height: 0, opacity: 0 }}
                      transition={{ duration: 0.3 }}
                      className="overflow-hidden"
                    >
                      <p className="pb-7 pr-8 md:pr-24 text-forest-600 leading-relaxed text-lg max-w-3xl">
                        {item.a}
                      </p>
                    </motion.div>
                  )}
                </AnimatePresence>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
